import React from "react";
import TempHome from "./tempSplash";

export default function NotFound() {
	return (
		<div style={{display:"flex", alignItems:"center", justifyContent:"center", flexFlow:"column noWrap"}}>
        < h1>404, Page Not Found</h1>
			<TempHome />
		</div>
	);
}
